import React, { memo, useMemo, useCallback, useContext } from 'react';
import style from './index.module.scss';
import TypeItem from './TypeItem';
import Price from './Price';
import IPList from './IPList';
import FactoryList from './FactoryList';
import { debounce } from 'lodash';
import useUrlState from '@ahooksjs/use-url-state';
import { Select } from 'antd';
import { useMallParams, orderingList } from '@/stores';
import type { MallParams } from '@/stores';
import globalContext from '@/configs/globalContext';
import MobileFator from './MobileFator';

export interface QueryType {
  ips?: string;
  price?: string;
  type?: string;
  ordering?: string;
  factory?: string;
}

export interface InitQueryType {
  ordering?: string;
  ips: number[];
  price: number[];
  type: number[];
  factory: number[];
}

interface Props {
  isNormalProduct?: boolean;
}

const Fator: React.FC<Props> = ({ isNormalProduct }) => {
  const { isMobile } = useContext(globalContext);
  const { updateMallParams } = useMallParams();
  const [query] = useUrlState<QueryType>({});
  // 修改查询参数
  const changeFator = useCallback(
    debounce(
      (fatorItem: MallParams) => {
        // console.log('修改查询参数', fatorItem);
        updateMallParams(fatorItem);
      },
      500,
      { trailing: true },
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [updateMallParams],
  );
  const initValue = useMemo(() => {
    return {
      ips: (query.ips || '').split(',').filter(Boolean).map(Number),
      type: (query.type || '').split(',').filter(Boolean).map(Number),
      price: (query.price || '').split(',').filter(Boolean).map(Number),
      factory: (query.factory || '').split('|').filter(Boolean).map(String),
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  return (
    <div className={style.fator}>
      {isMobile ? (
        <MobileFator
          isNormalProduct={isNormalProduct}
          changeFator={changeFator}
          initValues={{ ...initValue, ordering: query?.ordering }}
        />
      ) : (
        <>
          <Select
            suffixIcon={<span className="icon-caret"></span>}
            value={query?.ordering}
            style={{ width: '100%', marginBottom: '20px' }}
            onChange={(val) =>
              updateMallParams({
                ordering: val,
              })
            }
            options={orderingList}
          ></Select>
          {isNormalProduct && (
            <TypeItem changeFator={changeFator} initValue={initValue.type} />
          )}
          <Price changeFator={changeFator} initValue={initValue.price} />
          <IPList changeFator={changeFator} initValue={initValue.ips} />
          <FactoryList
            changeFator={changeFator}
            initValue={initValue.factory}
          />
        </>
      )}
    </div>
  );
};

export default memo(Fator);
